// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_to-integer.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_to-integer.js
// module chunks = 168707334958949